import type { ProjectInfoResponse } from '@/services/project';
import type { ProjectSummary } from '@/stores/project';

function parseArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string' && Boolean(item.trim()));
  }

  if (typeof value === 'string' && value.trim()) {
    return [value.trim()];
  }

  return [];
}

export function hasProjectSummaryData(summary: ProjectSummary | null): boolean {
  if (!summary) {
    return false;
  }

  const { websiteInfo } = summary;
  return Boolean(
    summary.summary
    || websiteInfo.overview
    || websiteInfo.websiteType
    || websiteInfo.language
    || websiteInfo.industry
    || websiteInfo.targetAudience.length
    || websiteInfo.goals.length
    || summary.designPreferences?.length
    || summary.contentPreferences?.length
    || summary.behaviorPreferences?.length
    || summary.brandGuidelines?.length
    || summary.functionalRequirements?.length,
  );
}

export function transformProjectInfo(apiData: ProjectInfoResponse): ProjectSummary {
  return {
    summary: apiData?.summary || '',
    websiteInfo: {
      overview: apiData?.website_info?.overview || '',
      websiteType: apiData?.website_info?.website_type || '',
      language: apiData?.website_info?.language || '',
      industry: apiData?.website_info?.industry || '',
      targetAudience: parseArray(apiData?.website_info?.target_audience),
      goals: parseArray(apiData?.website_info?.goals),
    },
    designPreferences: parseArray(apiData?.design_preferences),
    contentPreferences: parseArray(apiData?.content_preferences),
    behaviorPreferences: parseArray(apiData?.behavior_preferences),
    brandGuidelines: parseArray(apiData?.brand_guidelines),
    functionalRequirements: parseArray(apiData?.website_info?.functional_requirements),
  };
}
